/* eslint-disable @typescript-eslint/ban-ts-ignore */

import React, { ChangeEvent, useState } from "react";

import { Preview } from "@creatomate/preview";
import { Button, Icon } from "@culturehq/components";
// @ts-ignore
import { signUpload } from "@culturehq/client";

import { useAWSUpload } from "app/hooks";
import { Trans, errorService } from "app/utils";

import createElement from "components/stories/video-studio/utils/creatomate/createElement";

interface UploadAudioProps {
  preview: Preview;
}

const UploadAudio: React.FC<UploadAudioProps> = ({ preview }) => {
  const { waitForS3 } = useAWSUpload();
  const [uploading, setUploading] = useState(false);

  const applyModifications = async (modifications: Record<string, any>) => (
    preview.applyModifications(modifications)
  );

  const handleSelectedAudio = async (audio: File) => {
    if (!uploading) {
      setUploading(true);
      const tempUrl = `https://platform.culturehq.com/${Date.now()}`;
      try {
        await preview.cacheAsset(tempUrl, audio);
      } catch (error) {
        errorService.error(`Error caching the file: ${error}`);
      }
      const auditoTrack = preview.getElements()?.find(track => track.source.type === "audio");
      const id = await createElement({
        type: "audio",
        name: `Audio - ${audio.name}`,
        source: tempUrl,
        track: auditoTrack?.track
      }, preview);
      setUploading(false);
      const audioUrl = await signUpload(audio, (_audioProgress: number) => {});
      await waitForS3(2000, { [`${id}.source`]: audioUrl }, applyModifications);
    }
  };

  const handleFileInputChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) { await handleSelectedAudio(selectedFile); }
  };

  const handleUpload = () => {
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.click();
    }
  };

  return (
    <label htmlFor="fileInput">
      <input
        type="file"
        id="fileInput"
        onChange={handleFileInputChange}
        accept=".mp3, .aac, .wav, .ogg, .flac"
        style={{ display: "none" }}
      />
      <Button className="invert-icon" inverted onClick={handleUpload}>
        <Icon icon="download" /><Trans>Upload Audio</Trans>
      </Button>
    </label>
  );
};

export default UploadAudio;
